// What the logged-in CRM user may do: role, bound branch and per-user permissions.
// Stored at login and refreshed from /crm/users/me; the backend enforces the same rules.

const API = process.env.REACT_APP_BACKEND_URL;

export const crmRole = () => localStorage.getItem('crm_role') || '';

// Branch the user works in, or '' when they work across all branches.
export const crmBranch = () => localStorage.getItem('crm_branch') || '';

export function crmCan(key) {
    if (crmRole() === 'administrator') return true;
    try {
        return !!JSON.parse(localStorage.getItem('crm_permissions') || '{}')[key];
    } catch (e) {
        return false;
    }
}

export function storeCrmAccess(data) {
    if (data.crm_role) localStorage.setItem('crm_role', data.crm_role);
    else localStorage.removeItem('crm_role');
    if (data.crm_branch) localStorage.setItem('crm_branch', data.crm_branch);
    else localStorage.removeItem('crm_branch');
    if (data.crm_permissions) localStorage.setItem('crm_permissions', JSON.stringify(data.crm_permissions));
    else localStorage.removeItem('crm_permissions');
}

export function refreshCrmAccess() {
    return fetch(`${API}/crm/users/me`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` },
    })
        .then((res) => (res.ok ? res.json() : null))
        .then((data) => { if (data) storeCrmAccess(data); return data; })
        .catch(() => null);
}

// Menu entries hidden unless the user has the permission.
const MENU_PERMISSIONS = {
    crm_admin_postavke: 'admin_settings',
    crm_izvjestaji: 'reports',
    crm_uvoz_kina: 'china_import',
    crm_inventura: 'inventura',
    crm_prijenosnice: 'prijenosnice',
    crm_skeniranje_kalkulacija: 'calculations',
};

export function filterCrmMenu(items) {
    if (!items) return items;
    return items
        .filter((it) => !MENU_PERMISSIONS[it.id] || crmCan(MENU_PERMISSIONS[it.id]))
        .map((it) => (it.children ? { ...it, children: filterCrmMenu(it.children) } : it));
}
